import React, { useEffect, useRef } from "react";

export default function SearchInput({ searchTerm, setSearchTerm, inputRef }) {
  // useEffect(() => {
  //   inputRef.current?.focus();
  // }, [inputRef.current]);

  return (
    <form
      role="search"
      className="search-form"
      onSubmit={(event) => {
        event.preventDefault();
      }}
    >
      <label className="search-label" htmlFor="search-input">
        Search all of Spring
      </label>
      <input
        id="search-input"
        autoFocus={true}
        type="search"
        autoComplete="off"
        name="q"
        className="search-input"
        placeholder="Search term"
        // tabIndex={-1}
        value={searchTerm}
        ref={inputRef}
        onChange={(event) => {
          setSearchTerm(event.target.value);
        }}
      />
    </form>
  );
}
